import { AxiosError } from 'axios';
import { useQuery, UseQueryResult, UseQueryOptions } from '@tanstack/react-query';
import { couponQueryKeys } from '../../../constants/queryKeys/coupon';
import { CouponApiV2 } from '../../../lib/api/coupon/CouponApiV2';

type IssueHistoryListResponse = Awaited<ReturnType<typeof CouponApiV2.getCouponIssueHistoryList>>;

type IssueHistoryListOption = {
  searchOption: Record<string, unknown>;
  pagination: { pageNum: number; pageSize: number };
};

type IssueHistoryListData = {
  list: Record<string, unknown>[];
  totalCount: number;
  adminSelectList: { id: number; name: string }[];
  pagination: { pageNum: number; pageSize: number; pages: number; totalCnt: number };
};

export const useCouponIssueHistoryListQuery = (
  option: IssueHistoryListOption,
  options?: UseQueryOptions<IssueHistoryListResponse, AxiosError, IssueHistoryListData>,
): UseQueryResult<IssueHistoryListData, AxiosError> => {
  return useQuery(
    couponQueryKeys.couponIssueHistoryList(option),
    () => CouponApiV2.getCouponIssueHistoryList({
      searchOption: option.searchOption,
      pagination: option.pagination,
    }),
    {
      select: (res: IssueHistoryListResponse) => {
        const totalCnt = res.data.totalCnt ?? 0;
        return {
          list: res.data.couponIssueHistoryList ?? [],
          totalCount: totalCnt,
          adminSelectList: res.data.adminSelectList ?? [],
          pagination: {
            pageNum: option.pagination.pageNum,
            pageSize: option.pagination.pageSize,
            pages: Math.ceil(totalCnt / Math.max(1, option.pagination.pageSize)) || 1,
            totalCnt,
          },
        };
      },
      ...options,
    },
  );
};
